<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getPreOrNextToday,
} from '@qx/utils/index';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {
  costDetailCostType,
} from 'api/cost';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        costTypeOptions: [], // 费用类型
        orgIdOptions: [], // 费用归属
        stateOptions: [], // 申请状态
        form: [
          {
            label: '申请时间',
            value: 'Time',
            type: 'date',
            default: [getPreOrNextToday(-1) + ' 00:00:00', new Date()],
            attr: {
              type: 'daterange',
            },
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 费用类型
            label: '费用类型',
            value: 'costType',
            type: 'cascader',
            normal: true,
            default: [-1],
            placeholder: '请选择费用类型',
          },
          { // 申请单号
            label: '申请单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入申请单号',
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 费用归属
            label: '费用归属',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请选择费用归属',
          },
          { // 申请状态
            label: '申请状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择申请状态',
          },
          { // 申请人
            label: '申请人',
            value: 'applyUserName',
            type: 'input',
            placeholder: '请输入申请人',
          },
          { // 申请金额
            label: '申请金额',
            value: 'Amt',
            type: 'inputrange',
            placeholder: '请输入申请金额',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 申请时间
      if (searchBoxData.Time[0]) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0], 1);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1], 1);
      }
      delete searchBoxData.Time;
      // 申请金额
      if (searchBoxData.Amt[0]) {
        searchBoxData.startAmt = searchBoxData.Amt[0];
      }
      if (searchBoxData.Amt[1]) {
        searchBoxData.endAmt = searchBoxData.Amt[1];
      }
      delete searchBoxData.Amt;
      // 费用类型
      searchBoxData.costType = searchBoxData.costType[searchBoxData.costType.length - 1];
      searchBoxData.waitDeal = true;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.searchBoxData.costTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...await costDetailCostType(),
    ];
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...await getDepartmentAllList(),
    ];
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_APPLY_STATE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
